import { render, staticRenderFns } from "./settlementDialog.vue?vue&type=template&id=dd42c840&scoped=true&"
import script from "./settlementDialog.vue?vue&type=script&lang=js&"
export * from "./settlementDialog.vue?vue&type=script&lang=js&"
import style0 from "./settlementDialog.vue?vue&type=style&index=0&id=dd42c840&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd42c840",
  null
  
)

export default component.exports